<section class="feature-section" *ngIf="featureContent && featureContent.featureActive">
      <div class="box">
            <h2 id="featureSection" class="sub-heading" [innerHTML]="featureContent?.heading"></h2>
            <ngx-slick-carousel #slickModal="slick-carousel" [config]="slideConfig" (init)="slickInit($event)"
                  (breakpoint)="breakpoint($event)" (afterChange)="afterChange($event)"
                  (beforeChange)="beforeChange($event)" class="slide-wrapper" (touchstart)="swipe($event, 'start')"
                  (touchend)="swipe($event, 'end')">
                  <div ngxSlickItem *ngFor="let feature of featureContent?.features" class="slide">
                        <div class="desc">
                              <a role="link" [mktRouterLink]="feature.link">
                                    <div><img  [cache]="feature.imagePath" [lazyload]="feature.imagePath" [attr.alt]="feature.txtContent" width="60px"
                                          height="60px" role="presentation" aria-hidden="true">
                                    <span [innerHTML]="feature.txtContent | adaFriendlyName: 'ignoreHtmlTags'"></span></div>
                              </a>
                        </div>
                  </div>
            </ngx-slick-carousel>
            <div class="spacer" role="presentation" aria-hidden="true"></div>
      </div>
</section>
